import { render, staticRenderFns } from "./companyBusiness.vue?vue&type=template&id=98b412ae&scoped=true&"
import script from "./companyBusiness.vue?vue&type=script&lang=js&"
export * from "./companyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./companyBusiness.vue?vue&type=style&index=0&id=98b412ae&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b412ae",
  null
  
)

export default component.exports